<template>
  <div>
    <a-card>
      <a-row>
        <a-col :span="16">
          <div class="box">
            <a-row>
              <a-col :span="12">
                <button class="backBtn" @click="back()">返回上级</button>
                </button></a-col>
              <a-col :span="12" >
                <a-radio-group :options="options" :default-value="value2" @change="onChange" />
              </a-col>
            </a-row>
            <div id="mapChart" class="chart"></div>
          </div>
        </a-col>
        <a-col :span="8">
          <div style="display:flex;justify-content:space-between;margin-bottom:20px">
            <a-month-picker placeholder="选择日期" @change="onChangeDate" :v-model="createTime" />
          </div>

          <a-table
            :columns="columns2"
            :data-source="cityData"
            size="small"
            v-if="haveCity"
            :pagination="false"
            :scroll="{y: 400}">
            <span slot="orderCountName" style="text-align:center">{{ type==2?'下单量':'交易成功订单量' }}</span>
            <span slot="orderCount" slot-scope="orderCount">{{ orderCount }}</span>
          </a-table>
          <a-table
            :columns="columns1"
            :data-source="cityData"
            size="small"
            v-else
            :pagination="false"
            :scroll="{ y: 400 }">
            <span slot="orderCountName">{{ type==2?'下单量':'交易成功订单量' }}</span>
            <span slot="orderCount" slot-scope="orderCount">{{ orderCount }}</span>
          </a-table>

        </a-col>
      </a-row>
    </a-card>
  </div>
</template>

<script>
import cityMap from '../../assets/map/js/china-main-city-map.js'
import echarts from 'echarts'
import axios from 'axios'
import { getProvinceStatistics, getcityStatistics } from '@/api/dashboard/dataCenter.js'
// import registerAndsetOption from '@/js/echarts-map'

// 中国地图（第一级地图）的ID、Name、Json数据
var chinaId = 100000
var chinaName = 'china'
var chinaJson = null
// 记录父级ID、Name
var mapStack = []
var parentId = null
var parentName = null
// Echarts地图全局变量，主要是在返回上级地图的方法中会用到
var myChart = null
export default {
  name: 'ChinaMap',
  props: {
    msg: String
  },
  data () {
    return {
      options: [
        { label: '下单量', value: 2 },
        { label: '交易成功订单量', value: 1 }
      ],
      value2: 2,
      outvalue: null,
      city: null,
      type: 2,
      provinceCode: null, // 省份
      clickCity: null, // 点击获取省份ID
      provinceName: '', // 省份名字
      total: null, // 总单数
      cityData: [],
      haveCity: null, // 有无城市
      columns1: [{
        title: '排名',
        customRender: (text, record, index) => `${index + 1}`,
        key: 'name',
        align: 'center',
        width: 50,
        scopedSlots: { customRender: 'name' }
      }, {
        title: '省/市',
        dataIndex: 'provinceName',
        key: 'provinceName',
        align: 'center',
        width: 100,
        scopedSlots: { customRender: 'provinceName' }
      }, {
        slots: { title: 'orderCountName' },
        dataIndex: 'orderCount',
        key: 'orderCount',
        align: 'center',
        width: 120,
        scopedSlots: { customRender: 'orderCount' }
      }, {
        title: '占比',
        dataIndex: 'rate',
        key: 'rate',
        align: 'center',
        width: 50,
        scopedSlots: { customRender: 'rate' }
      }],
      columns2: [{
        title: '排名',
        customRender: (text, record, index) => `${index + 1}`,
        key: 'name',
        align: 'center',
        width: 50,
        scopedSlots: { customRender: 'name' }
      }, {
        title: '省/市',
        dataIndex: 'cityName',
        align: 'center',
        key: 'cityName',
        width: 100,
        scopedSlots: { customRender: 'cityName' }
      }, {
        slots: { title: 'orderCountName' },
        dataIndex: 'orderCount',
        key: 'orderCount',
        align: 'center',
        width: 120,
        scopedSlots: { customRender: 'orderCount' }
      }, {
        title: '占比',
        dataIndex: 'rate',
        key: 'rate',
        align: 'center',
        width: 50,
        scopedSlots: { customRender: 'rate' }
      }],
      spinning: true,
      createTime: ''
    }
  },
  mounted () {
  },
  created () {
    this.mapChart('mapChart')
  },
  methods: {
    getProvinceArr (mapJson, city) {
      const arr1 = mapJson.features
      const arr2 = city
      arr1.forEach(item => {
        arr2.forEach(v => {
          if (v.provinceCode && !v.cityCode) {
            if (item.id == v.provinceCode) {
              item.orderCount = v.orderCount
            }
          } else if (v.cityCode && v.cityCode) {
            if (item.id == v.cityCode) {
              item.orderCount = v.orderCount
            }
          }
        })
      })
      var arr = []
      arr1.forEach((item) => {
        arr.push(item.orderCount)
      })
      return arr
    },
    async  getProvinceStatistics () {
      try {
        const res = await getProvinceStatistics({
          type: this.type,
          createTime: this.createTime
        })
        this.city = res.data.map(item => {
          return item
        })
        this.cityData = res.data
        this.total = res.data[0].orderCount
        this.haveCity = res.data[0].cityCode
      } catch (err) {
        console.log(err)
      }
    },
    async getcityStatistics () {
      try {
        const res = await getcityStatistics({
          type: this.type,
          provinceCode: this.clickCity,
          createTime: this.createTime
        })
        this.city = res.data.map(item => {
          return item
        })
        this.cityData = res.data
        this.haveCity = res.data[0].cityCode
        this.total = res.data[0].orderCount
      } catch (err) {
        console.log(err)
      }
    },
    /**
     * 返回上一级地图
     */
    back () {
      this.spinning = true
      this.clickCity = ''
      this.mapChart('mapChart')
    },
    /**
     * Echarts地图
     */
    getcitymapData () {
      axios
        .get('/static/json/map/' + this.clickCity + '.json', {})
        .then(response => {
          const mapJson = response.data
          myChart = echarts.init(document.getElementById('mapChart'))
          this.getcityStatistics().then(async () => {
            this.outvalue = await this.getProvinceArr(mapJson, this.city)
            this.registerAndsetOption(
              myChart,
              this.clickCity,
              this.provinceName,
              mapJson,
              true
            )
          })
        })
    }, // 获取城市数据
    getProvinceMapData () {
      axios.get('/static/json/map/' + chinaId + '.json', {}).then((response) => {
        const mapJson = response.data
        this.getProvinceStatistics().then(async () => {
          this.outvalue = await this.getProvinceArr(mapJson, this.city)
          myChart = echarts.init(document.getElementById('mapChart'))
          this.registerAndsetOption(myChart, chinaId, chinaName, mapJson, false)
        })
      })
    },

    mapChart (divid) {
      const _this = this
      axios.get('/static/json/map/' + chinaId + '.json', {}).then((response) => {
        const mapJson = response.data
        _this.getProvinceStatistics().then(async () => {
          _this.outvalue = await _this.getProvinceArr(mapJson, _this.city)
          chinaJson = mapJson
          myChart = echarts.init(document.getElementById(divid))
          _this.registerAndsetOption(myChart, chinaId, chinaName, mapJson, false)
          parentId = chinaId
          parentName = 'china'
          myChart.on('click', function (param) {
            if (!_this.clickCity) {
              var cityId = cityMap[param.name]
              _this.provinceName = param.name
              _this.clickCity = cityId
              // 代表有下级地图
              axios
                .get('/static/json/map/' + cityId + '.json', {})
                .then(response => {
                  _this.getcityStatistics().then(async () => {
                    const mapJson = response.data
                    _this.outvalue = await _this.getProvinceArr(mapJson, _this.city)
                    _this.registerAndsetOption(
                      myChart,
                      cityId,
                      param.name,
                      mapJson,
                      true
                    )
                  })
                })
            }
          })
        })
      })
    },
    onChange (e) {
      this.type = e.target.value
      if (this.clickCity) {
        this.getcitymapData()
      } else {
        this.getProvinceMapData()
      }
    },
    onChangeDate (date, dateString) {
      this.createTime = dateString
      if (this.clickCity) {
        this.getcitymapData()
      } else {
        this.getProvinceMapData()
      }
    },
    registerAndsetOption (myChart, id, name, mapJson, flag) {
      echarts.registerMap(name, mapJson)
      myChart.setOption({
        visualMap: {
          min: 0,
          max: this.total,
          itemWidth: 10,
          itemHeight: 89,
          left: '20',
          bottom: '10',
          text: ['高', '低'],
          textStyle: {
            color: '#666666',
            fontSize: 13
          },
          inRange: {
            color: ['#7a92db', '#1a2980']
          },
          outOfRange: {
            show: false
          }
        },
        series: [{
          type: 'map',
          map: name,
          label: {
            emphasis: {
              textStyle: {
                color: 'black',
                fontWeight: 'bold',
                textBorderColor: 'white'
              }
            }
          },
          itemStyle: {
            normal: {
              areaColor: '#7a92db',
              borderColor: '#fff',
              borderWidth: 1
            },
            emphasis: {
              areaColor: '#3b488e'
            }
          },
          data: this.initMapData(mapJson)
        }
        ]
      })
      window.onresize = myChart.resize
    },
    initMapData (mapJson) {
      var mapData = []
      for (var i = 0; i < mapJson.features.length; i++) {
        mapData.push({
          name: mapJson.features[i].properties.name,
          // id:mapJson.features[i].id
          value: this.outvalue[i]
        })
      }
      return mapData
    }
  }
}
/**
 *
 * @param {*} myChart
 * @param {*} id        省市县Id
 * @param {*} name      省市县名称
 * @param {*} mapJson   地图Json数据
 * @param {*} flag      是否往mapStack里添加parentId，parentName
 */
</script>

<style scoped>
.box {
  width: 100%;
  height: 60vh;
  margin: 0;
}

.chart {
  height: 100%;
}
.backBtn {
  top: 0;
  background-color: #00c298;
  border: 0;
  color: #fff;
  height: 1.6875rem;
  font-family: Microsoft Yahei;
  font-size: 1em;
  cursor: pointer;
}
/* canvas{
  height: 100vh
} */
</style>
